(function () {
  if (window.__shopByTopicLoaded) return;
  window.__shopByTopicLoaded = true;

  var CACHE_VERSION = 1;
  var CACHE_TTL = 6 * 60 * 60 * 1000;
  var CACHE_PREFIX = "whm-shop-by-topic-v" + CACHE_VERSION + ":";
  var FALLBACK_SEARCH_URL = "https://services.mybcapps.com/bc-sf-filter/search";
  var BEST_SELLER_SORT = "number-extra-sort1-descending";

  function titleCase(value) {
    return String(value || "")
      .trim()
      .replace(/\s+/g, " ")
      .replace(/\b\w/g, function (character) {
        return character.toUpperCase();
      });
  }

  function normalizeTerms(terms) {
    var seen = {};

    return (Array.isArray(terms) ? terms : [])
      .map(function (term) {
        return String(term || "").trim();
      })
      .filter(function (term) {
        var key = term.toLowerCase();
        if (!term || seen[key]) return false;
        seen[key] = true;
        return true;
      })
      .slice(0, 5);
  }

  function findPopularTerms(value, seen, depth) {
    if (
      !value ||
      typeof value !== "object" ||
      depth > 6 ||
      seen.indexOf(value) !== -1
    )
      return null;
    seen.push(value);

    var direct =
      value.searchBoxOnclick && value.searchBoxOnclick.searchTermSuggestion;
    if (direct && direct.status !== false && Array.isArray(direct.data)) {
      var directTerms = normalizeTerms(direct.data);
      if (directTerms.length === 5) return directTerms;
    }

    var keys;
    try {
      keys = Object.keys(value).slice(0, 80);
    } catch (error) {
      return null;
    }

    for (var index = 0; index < keys.length; index += 1) {
      var child;
      try {
        child = value[keys[index]];
      } catch (error) {
        continue;
      }

      var found = findPopularTerms(child, seen, depth + 1);
      if (found) return found;
    }

    return null;
  }

  function readTermsFromBoostGlobals() {
    var roots = [
      window.boostWidgetIntegration,
      window.boostWidgetIntegrationConfig,
      window.boostSDData,
      window.boostSDAppConfig,
    ];

    for (var index = 0; index < roots.length; index += 1) {
      var found = findPopularTerms(roots[index], [], 0);
      if (found) return found;
    }

    return null;
  }

  function readTermsFromBoostScript() {
    var scripts = document.scripts || [];
    var pattern =
      /"searchTermSuggestion"\s*:\s*\{\s*"label"\s*:\s*"(?:\\.|[^"])*"\s*,\s*"status"\s*:\s*(?:true|false)\s*,\s*"data"\s*:\s*(\[[^\]]*\])/;

    for (var index = 0; index < scripts.length; index += 1) {
      var source = scripts[index].textContent || "";
      if (source.indexOf("searchBoxOnclick") === -1) continue;

      var match = source.match(pattern);
      if (!match) continue;

      try {
        var terms = normalizeTerms(JSON.parse(match[1]));
        if (terms.length === 5) return terms;
      } catch (error) {
        // Continue to the next Boost configuration block.
      }
    }

    return null;
  }

  function getPopularTerms() {
    return readTermsFromBoostGlobals() || readTermsFromBoostScript();
  }

  function findSearchUrl(value, seen, depth) {
    if (
      !value ||
      typeof value !== "object" ||
      depth > 5 ||
      seen.indexOf(value) !== -1
    )
      return null;
    seen.push(value);

    if (
      typeof value.searchUrl === "string" &&
      /\/bc-sf-filter\/search\/?$/.test(value.searchUrl)
    ) {
      return value.searchUrl.replace(/\/$/, "");
    }

    var keys;
    try {
      keys = Object.keys(value).slice(0, 80);
    } catch (error) {
      return null;
    }

    for (var index = 0; index < keys.length; index += 1) {
      var child;
      try {
        child = value[keys[index]];
      } catch (error) {
        continue;
      }

      var found = findSearchUrl(child, seen, depth + 1);
      if (found) return found;
    }

    return null;
  }

  function getBoostSearchUrl() {
    return (
      findSearchUrl(window.boostWidgetIntegration, [], 0) ||
      findSearchUrl(window.boostWidgetIntegrationConfig, [], 0) ||
      FALLBACK_SEARCH_URL
    );
  }

  function getCachedTopics(cacheKey, signature) {
    try {
      var cached = JSON.parse(window.localStorage.getItem(cacheKey));
      if (
        cached &&
        cached.expiresAt > Date.now() &&
        cached.signature === signature &&
        Array.isArray(cached.items) &&
        cached.items.length === 5
      ) {
        return cached.items;
      }
    } catch (error) {
      // A blocked or full localStorage should not prevent the section from loading.
    }

    return null;
  }

  function cacheTopics(cacheKey, signature, items) {
    try {
      window.localStorage.setItem(
        cacheKey,
        JSON.stringify({
          expiresAt: Date.now() + CACHE_TTL,
          signature: signature,
          items: items,
        })
      );
    } catch (error) {
      // The fetched result remains usable for this page view when storage is unavailable.
    }
  }

  function imageFromProduct(product) {
    if (!product) return "";
    if (
      product.images_info &&
      product.images_info[0] &&
      product.images_info[0].src
    ) {
      return product.images_info[0].src;
    }

    if (product.images && typeof product.images === "object") {
      var imageKeys = Object.keys(product.images);
      if (imageKeys.length) return product.images[imageKeys[0]];
    }

    return "";
  }

  function collectionImage(response, term) {
    var collections = (response && response.collections) || [];
    var normalizedTerm = term.toLowerCase();
    var collection =
      collections.find(function (item) {
        return (
          String(item.handle || "").toLowerCase() ===
          normalizedTerm.replace(/\s+/g, "-")
        );
      }) || collections[0];

    return collection && collection.image && collection.image.src
      ? collection.image.src
      : "";
  }

  function searchDestination(term) {
    return (
      "/search?q=" +
      encodeURIComponent(term).replace(/%20/g, "+") +
      "&sort=" +
      BEST_SELLER_SORT
    );
  }

  async function fetchTopic(term, shopDomain) {
    var requestUrl = new URL(getBoostSearchUrl() + "/suggest");
    requestUrl.searchParams.set("shop", shopDomain);
    requestUrl.searchParams.set("q", term);
    requestUrl.searchParams.set("product_limit", "1");
    requestUrl.searchParams.set("suggestion_limit", "0");
    requestUrl.searchParams.set("collection_limit", "5");
    requestUrl.searchParams.set("page_limit", "0");
    requestUrl.searchParams.set("sort", BEST_SELLER_SORT);
    requestUrl.searchParams.set("product_available", "true");

    var response = await fetch(requestUrl.toString(), {
      headers: { Accept: "application/json" },
    });

    if (!response.ok)
      throw new Error("Boost topic request failed with " + response.status);

    var payload = await response.json();
    var product = payload.products && payload.products[0];
    var image = imageFromProduct(product) || collectionImage(payload, term);
    if (!image)
      throw new Error("Boost returned no topic thumbnail for " + term);

    return {
      term: term,
      title: titleCase(term),
      image: image,
      imageAlt:
        product && product.title
          ? product.title
          : titleCase(term) + " church media",
      url: searchDestination(term),
    };
  }

  function renderTopicCard(card, item, index) {
    var media = card.querySelector("[data-topic-media]");
    var title = card.querySelector("[data-topic-title]");
    var button = card.querySelector("[data-topic-button]");
    var image = document.createElement("img");

    image.className = "shop-by-topic__image";
    image.src = item.image;
    image.alt = item.imageAlt;
    image.loading = "lazy";
    image.decoding = "async";
    image.width = 960;
    image.height = 540;

    media.appendChild(image);
    title.textContent = item.title;
    card.href = item.url;
    card.setAttribute("aria-label", "Browse " + item.title + " Media");

    if (index === 0 && button) {
      button.textContent = "Browse " + item.title + " Media";
    }
  }

  function renderSection(section, items) {
    var cards = section.querySelectorAll("[data-topic-card]");
    if (cards.length < 5 || items.length < 5)
      throw new Error("Five topic cards are required");

    items.forEach(function (item, index) {
      renderTopicCard(cards[index], item, index);
    });

    section.classList.add("is-ready");
    section.setAttribute("aria-busy", "false");
    var status = section.querySelector("[data-topic-status]");
    if (status) status.textContent = "Popular topics loaded.";
  }

  function showError(section) {
    section.classList.add("has-error");
    section.setAttribute("aria-busy", "false");
  }

  function runWhenNearViewport(section, callback) {
    if (!("IntersectionObserver" in window)) {
      callback();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (entry) {
            return entry.isIntersecting;
          })
        )
          return;
        observer.disconnect();
        callback();
      },
      { rootMargin: "600px 0px" }
    );

    observer.observe(section);
  }

  function getOverrides(section) {
    var raw = section.dataset.topicOverrides;
    if (!raw) return {};

    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function overrideToItem(override) {
    return {
      term: override.label,
      title: override.label,
      image: override.image,
      imageAlt: override.imageAlt || override.label,
      url: searchDestination(override.label),
    };
  }

  async function loadSection(section) {
    if (section.dataset.topicInitialized === "true") return;
    section.dataset.topicInitialized = "true";

    var overrides = getOverrides(section);
    var items = [undefined, undefined, undefined, undefined, undefined];
    var neededIndexes = [];

    for (var slot = 0; slot < 5; slot += 1) {
      var override = overrides[slot];
      if (override && override.label && override.image) {
        items[slot] = overrideToItem(override);
      } else {
        neededIndexes.push(slot);
      }
    }

    var shopDomain = section.dataset.shopDomain;
    var terms = null;

    if (neededIndexes.length) {
      terms = getPopularTerms();
      if (!terms || terms.length !== 5) {
        showError(section);
        return;
      }
    }

    var signature =
      (section.dataset.topicOverrides || "") +
      "::" +
      (terms ? terms.join("|").toLowerCase() : "");
    var cacheKey = CACHE_PREFIX + shopDomain;
    var cached = getCachedTopics(cacheKey, signature);

    if (cached) {
      renderSection(section, cached);
      return;
    }

    try {
      if (neededIndexes.length) {
        var fetched = await Promise.all(
          neededIndexes.map(function (index) {
            return fetchTopic(terms[index], shopDomain).then(function (item) {
              return { index: index, item: item };
            });
          })
        );

        fetched.forEach(function (pair) {
          items[pair.index] = pair.item;
        });
      }

      cacheTopics(cacheKey, signature, items);
      renderSection(section, items);
    } catch (error) {
      console.warn("Shop by topic could not load:", error);
      showError(section);
    }
  }

  function initialize(root) {
    var sections = (root || document).querySelectorAll("[data-shop-by-topic]");
    sections.forEach(function (section) {
      runWhenNearViewport(section, function () {
        loadSection(section);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialize(event.target);
  });
})();
